import logger from '../logger.js';

/**
 * Format logs for DataDog.
 */
const format = ({
  request,
  response,
  config,
  ...restProps
}) => {
  const endTime = new Date();
  let logObj = {};
  if (!config) {
    return logObj;
  }

  // Note that the URL is built up from the config object, which is more likely
  // to exist even if the response and request objects somehow don't
  const search = config.params ? `?${config.paramsSerializer(config.params)}` : '';
  const url = new URL(`/${config.url}${search}`.replace(/\/\//g, '/'), config.baseURL);

  // Also grab the headers from the config obj
  const {
    headers = {}
  } = config;

  // delete these so we don't log the data in DataDog for security purposes
  headers === null || headers === void 0 ? true : delete headers.cookie;
  headers === null || headers === void 0 ? true : delete headers.Authorization;
  const normalisedHeaders = Object.keys(headers).reduce((acc, key) => {
    acc[key.toLowerCase()] = headers[key];
    return acc;
  }, {});

  // Attempt to parse the payload as JSON for better readability
  let payload;
  try {
    payload = JSON.parse(config.data);
  } catch (err) {
    payload = config.data;
  }
  try {
    var _config$method;
    logObj = {
      duration: (endTime - config._startTime) * 1000000,
      // in nanoseconds
      http: {
        url: url.href,
        status_code: response === null || response === void 0 ? void 0 : response.status,
        method: config === null || config === void 0 ? void 0 : (_config$method = config.method) === null || _config$method === void 0 ? void 0 : _config$method.toUpperCase(),
        referer: normalisedHeaders.referer || normalisedHeaders.referrer,
        useragent: normalisedHeaders['user-agent'],
        headers,
        contentLength: response === null || response === void 0 ? void 0 : response.headers['content-length'],
        payload,
        url_details: {
          host: url.hostname,
          port: url.port,
          path: url.pathname,
          queryString: config.params,
          scheme: url.protocol.replace(':', '')
        }
      },
      ...restProps
    };
  } catch (err) {
    logger.error(err); // In case log formatting goes wrong
  }

  return logObj;
};
export const debugRequests = () => ({
  success: config => {
    config._startTime = new Date();
    return config;
  }
});
export const debugResponses = ({
  apiName
} = {}) => {
  const api = `${apiName ? apiName.charAt(0).toUpperCase() + apiName.slice(1) : ''} API`.trim();
  return {
    success: response => {
      const {
        config,
        request
      } = response || {};
      logger.debug(`${api} Request`, format({
        config,
        response,
        request,
        api
      }));
      return response;
    },
    error: error => {
      const {
        config,
        request,
        response,
        message
      } = error;
      const {
        data,
        status
      } = response || {};
      const fullMessage = message ? `${api} Error: ${message}` : `${api} Error`;
      const log = !Number.isFinite(status) || status >= 500 ? logger.error : logger.warn;
      log(new Error(fullMessage), format({
        config,
        request,
        response,
        api,
        data
      }));
      throw error;
    }
  };
};